import * as React from 'react'
import { FormGroup, FormControl, Col, OverlayTrigger, Tooltip } from 'react-bootstrap'
import IconButton from '../../../../../common/IconButton'

interface InstantArticlesItemProps {
	name: string
	type: string
	componentClass?: React.ElementType
	placeholder?: string
	value: string
	onChange: (e: React.FormEvent<FormControl & HTMLInputElement>) => void
	editable?: boolean
	textClass?: string
	textElement?: React.ElementType
	toggleEditable: (name?: string) => void
	maxLength?: number
	minLength?: number
	focus?: boolean
	textStyle?: React.CSSProperties
	suggestion: boolean
}

type ValidationState = 'min' | 'max' | 'ok'

const validationText = (state: ValidationState) => {
	if (state === 'ok') {
		return 'success'
	}
	return 'error'
}

const validate = (text: string, maxLength?: number, minLength?: number): ValidationState => {
	if (minLength && text.length < minLength) {
		return 'min'
	}
	return maxLength && text.length > maxLength ? 'max' : 'ok'
}

const InstantArticlesItem = (props: InstantArticlesItemProps) => {
	const validationState = validate(props.value, props.maxLength, props.minLength)
	return props.editable ? (
		<FormGroup controlId={props.name} validationState={validationText(validationState)} style={{ margin: 0 }}>
			<Col md={11}>
				<OverlayTrigger
					trigger={['focus']}
					placement="bottom"
					overlay={
						<Tooltip id={props.name}>
							{props.value.length} / {props.maxLength} characters used
							{props.minLength && (
								<>
									<br />
									(Minimum {props.minLength} characters)
								</>
							)}
						</Tooltip>
					}
				>
					<FormControl
						type={props.type}
						componentClass={props.componentClass}
						placeholder={props.placeholder}
						value={props.value}
						onChange={props.onChange}
						onKeyPress={(event) => {
							if (event.key === 'Enter' && props.toggleEditable) {
								props.toggleEditable()
							}
						}}
						autoFocus={props.focus}
						maxLength={props.maxLength}
						rows={props.maxLength && Math.ceil(props.maxLength / 34)}
					/>
				</OverlayTrigger>
			</Col>
			<Col md={1}>
				<IconButton tooltipText="OK" onClick={props.toggleEditable} icon="fa-check text-success" />
			</Col>
		</FormGroup>
	) : (
		<FormGroup controlId={props.name} onClick={() => props.toggleEditable(props.name)} style={{ margin: 0 }}>
			<Col md={12}>
				{!props.suggestion && validationState !== 'ok' && props.value ? (
					<OverlayTrigger
						trigger={['hover']}
						placement="top"
						overlay={
							<Tooltip id={props.name}>
								{validationState === 'max'
									? 'The text in this field is too long! Click here to edit'
									: `The text in this field is too short! Click here to edit`}
							</Tooltip>
						}
					>
						<div
							className="bg-danger"
							style={{
								borderWidth: '2px',
								borderStyle: 'solid',
								borderColor: 'red',
								padding: '10px',
								display: 'flex',
							}}
						>
							<div
								style={{
									marginTop: 0,
									fontSize: '1.5em',
									paddingRight: '10px',
								}}
							>
								<i className="fa fa-exclamation-triangle text-danger" />
							</div>
							<div>{props.value ? props.value : props.placeholder}</div>
						</div>
					</OverlayTrigger>
				) : (
					<p className={props.textClass}>
						{props.textElement ? (
							<props.textElement className={props.textClass} style={props.textStyle}>
								{props.value ? props.value : props.placeholder}
							</props.textElement>
						) : props.value ? (
							props.value
						) : (
							props.placeholder
						)}
					</p>
				)}
			</Col>
		</FormGroup>
	)
}

export default InstantArticlesItem
